import { Dialog, DialogContent, DialogActions, Divider } from "@mui/material";
import CustomDialogTitle from "../CustomDialogTitle";
import FormActions from "./FormActions";

const FormDialog = ({
    isOpen,
    onClose,
    onSubmit,
    title = "Form",
    fullWidth = true,
    maxWidth = "md",
    actions,
    children,
    type = "default",
    noValidate = false,
}) =>
{
    return (
        <Dialog
            component="form"
            onSubmit={onSubmit}
            open={isOpen}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            role="form"
            noValidate={noValidate}
        >
            <CustomDialogTitle title={title} onClose={onClose} type={type} />
            <Divider />
            <DialogContent>{children}</DialogContent>
            <Divider />
            <DialogActions sx={{ padding: 2 }}>{actions ? actions : <FormActions onClose={onClose} />}</DialogActions>
        </Dialog>
    );
};

export default FormDialog;
